import React from "react";
import "../../styles/brand.css";
import "./Home.css";
import Layout from "../../components/Layout";
import HomeBanner from "./HomeBanner";
import HomeIntro from "./HomeIntro";
import HomeAbout from "./HomeAbout";
import HomeCoreServices from "./HomeCoreServices";
import HomeWhyChoose from "./HomeWhyChoose";
import HomeProcess from "./HomeProcess";
import HomeIndustries from "./HomeIndustries";
import HomeCommitment from "./HomeCommitment";
import HomeSectionFAQ from "./HomeSectionFAQ";
import { homeFaqContent } from "./homeContent";
import HomeFinalCta from "./HomeFinalCta";
import { HOME_SEO, buildHomeJsonLd } from "./homeSeo";

const MainHome = () => {
  return (
    <Layout
      title={HOME_SEO.title}
      description={HOME_SEO.description}
      keywords={HOME_SEO.keywords}
      canonical={HOME_SEO.canonical}
      ogImage={HOME_SEO.ogImage}
      jsonLd={buildHomeJsonLd()}
    >
      <main className="home-page brand-page overflow-x-hidden bg-white">
        <HomeBanner />
        <HomeIntro />
        <HomeAbout />
        <HomeCoreServices />
        <HomeWhyChoose />
        <HomeProcess />
        <HomeIndustries />
        <HomeCommitment />
        <HomeSectionFAQ
          id="home-page-faq-heading"
          subtitle=""
          faqs={homeFaqContent}
        />
        <HomeFinalCta />
      </main>
    </Layout>
  );
};

export default MainHome;
